module.exports = __webpack_public_path__ + "img/Middle-2-Bevel-Attachment-17.4cf49055.png";